export default __webpack_public_path__ + "static/media/majesticons_logout.ad04ce34.svg";